import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import axios from "axios";
import { withModal, withPageStatus } from "../common";
import DatePicker from "../common/DatePicker";
import SSNInput from "../common/SSNInput";
import Title from "../common/Title";
import ReadOnly from "../common/ReadOnly";
import ToggleVisibility from "../common/ToggleVisibility";
import { track } from "../../api/heap";
import isKey from "../../utilities/keyboard-events";
import moment from "moment";
import Back from "../../assets/Back";
import Logo from "../../assets/Logo";
import Eye from "../../assets/Eye";
import * as actions from "../../state/actions/onboarding";
import { ContactSupportOutlined } from "@material-ui/icons";

class PersonalInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorSSN: null,
      errorDob: null,
      showSSN: false,
      titleText: "Let's verify your identity",
      showSpinner: false,
      hasIdentityBeenVerified: false,
    };
  }

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    // if (
    //   !this.props.noPropsCheck &&
    //   (!this.props.user || !this.props.user.email.length)
    // ) {
    //   this.timeout = setTimeout(() => {
    //     this.timeout = null;
    //     this.props.startOver();
    //   }, 1000);
    // }
  }

  componentWillUnmount() {
    // if (this.timeout) {
    //   clearTimeout(this.timeout);
    // }
  }

  setTransition = () => {
    this.setState({ transitioning: true });
    track("ONBOARDING_PERSONAL_INFO_STEP_CLICKED_CONTINUE");
  }

  handlePrevious = () => {
    this.props.previousStep();
  };

  handleNext = async () => {
    const { applicationProgress, nextStep, identityCheck, pageComplete, updateUser, updateUserDatabase } = this.props;
    const { hasIdentityBeenVerified, transitioning } = this.state
    const { dob, email, ssn } = this.props.user
    if (transitioning) return;

    if (this.props.noValidate) {
      this.setTransition()
      nextStep();
      return;
    }


    if (pageComplete) {
      if (
        applicationProgress &&
        !applicationProgress.verifyId
      ) {
        updateUser({
          shouldEvaluate: true
        });
      }
      this.setTransition();
      nextStep();
      return;
    }

    const areFieldsValid = this.areFieldsValid();

    if (!areFieldsValid) { return }

    if (hasIdentityBeenVerified) {
      this.setTransition()
      this.save();
      return;
    }
    this.setState({ showSpinner: true })
    const saveSSNBeforeSentilink = await updateUserDatabase(email, { ssn: ssn.toString(), dob }, true);
    
    this.setState({ transitioning: true })


    if (!saveSSNBeforeSentilink.success) {
      this.setState({ transitioning: false })
      return;
    }
    
    const response = await identityCheck();
    this.setState({ hasIdentityBeenVerified: true })

    if ((response.data || {}).potentialMiskey) {
      this.setState({ titleText: 'Please re-enter your information', transitioning: false, showSpinner: false })
      return;
    } else {
      this.setTransition();
      this.save();
      return;
    }
  };

  getAge = dateString => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  areFieldsValid = () => {
    const { ssn, dob } = this.props.user;

    if (!ssn || ssn.length < 9) {
      track("ONBOARDING_ERROR_PERSONAL_INFO_STEP", {
        message: "invalid_ssn"
      });
      this.setState({ errorSSN: "A valid SSN is required" });
      this.setState({ transitioning: false });
      return false;
    } else {
      this.setState({
        errorSSN: null
      });
    }

    if (!dob) {
      this.setState({ errorDob: "A valid date of birth is required" });
      this.setState({ transitioning: false });
      return false;
    } else {
      this.setState({
        errorDob: null
      });
    }

    if (
      this.getAge(
        `${dob.substring(0, 4)}/${dob.substring(4, 6)}/${dob.substring(6, 8)}`
      ) < 18
    ) {
      this.setState({ errorDob: "Applicant must be over 18 years of age" });
      track("ONBOARDING_ERROR_PERSONAL_INFO_STEP", {
        message: "underage"
      });
      this.setState({ transitioning: false });
      return false;
    }

    this.setState({ error: null });

    return true;
  };

  save = async () => {
    if (!this.areFieldsValid) { // TODO: This does not actually CALL the function!
      track("ONBOARDING_ERROR_PERSONAL_INFO_STEP", {
        message: "invalid_fields"
      });
      this.setState({ transitioning: false });
      return false;
    }

    const {
      updateUserDatabase,
      updateStep,
      nextStep,
      user: { email, ssn, dob, w9Accepted }
    } = this.props;

    updateUserDatabase(
      email,
      {
        ssn: ssn.toString(),
        dob
        // w9Accepted
      },
      true
    ).then(result => {
      if (result.success) {
        this.props.updateUser({
          shouldEvaluate: true
        });
        nextStep();
      } else {
        updateStep("personalInformation", { error: "Error saving your data" });
        this.setState({ transitioning: false });
      }
    });
  };

  formatSSN = str => {
    let s = str.toString();
    let r;
    if (s.length <= 3) {
      r = str;
    } else if (s.length <= 5) {
      r = `${s.substr(0, 3)}-${s.substr(3, s.length - 1)}`;
    } else if (s.length <= 9) {
      r = `${s.substr(0, 3)}-${s.substr(3, 2)}-${s.substr(5, s.length - 1)}`;
    } else {
      r = `${s.substr(0, 3)}-${s.substr(3, 2)}-${s.substr(5, 4)}`;
    }
    return r;
  };

  obfuscateSSN = (str, showLastFour) => {
    if (!str) return;
    let s = str.toString();
    const mask = s => s.replace(/./g, "X");
    let o;
    if (s.length <= 3) {
      o = mask(s);
    } else if (s.length <= 5) {
      o = `${mask(s.substr(0, 3))}-${mask(s.substr(3, s.length - 1))}`;
    } else if (s.length <= 9) {
      o = `${mask(s.substr(0, 3))}-${mask(s.substr(3, 2))}-${showLastFour
        ? s.substr(5, s.length - 1)
        : mask(s.substr(5, s.length - 1))
        }`;
    } else {
      o = `${mask(s.substr(0, 3))}-${mask(s.substr(3, 2))}-${showLastFour ? s.substr(5, 4) : mask(s.substr(5, 4))
        }`;
    }
    return o;
  };

  renderW9 = () => (
    <span className="ml-4 text-sm mt-8">
      <span>I have read </span>
      <span
        className="cursor-pointer text-green-500"
        onClick={e => {
          track("ONBOARDING_PERSONAL_INFO_STEP_W9_MODAL_OPENED");
          this.props.context.openModal(e, "ElectronicW9Modal", {});
        }}
      >
        the W9 Agreement
      </span>
    </span>
  );

  render() {
    const {
      user: { dob, email, ssn, w9Accepted },
      networkingError,
      updateUser,
      pageComplete,
      step: { error: stepError }
    } = this.props;
    const { titleText } = this.state
    const { handleNext, formatAddress, parseAddress, renderW9 } = this;
    const { error, errorDob, errorSSN, showSSN } = this.state;
    return (
      <>
        {/* outerStack-mobile sm:outerStack needs marginBotton if there is a bottomBar */}
        <div
          className="outerStack-mobile sm:outerStack"
          style={{ marginBottom: 88 }}
          onKeyDown={e => {
            if (isKey(e, ["enter"])) {
              e.preventDefault();
              if (!w9Accepted) {
                return this.setState({
                  errorW9: "You must read the W9 Agreement."
                });
              }
              handleNext();
            }
          }}
        >
          <div className="innerStack">
            <Title
              text={titleText}
              disabled={pageComplete}
              disabledText={"Your personal information is being verified"}
            />
            {/* <div className="stepDescriptionText">
                You're almost halfway done. Don't stop now!
              </div> */}
            <ReadOnly readOnly={pageComplete}>
              {errorDob ? (
                <div className="errorText">{errorDob}</div>
              ) : (
                <p className="inputDescriptionText">Date of birth</p>
              )}
              <div>
                <DatePicker
                  defaultDate={dob}
                  dateChange={date => {
                    if (!date) {
                      this.setState({
                        errorDob: "Please enter a valid date"
                      });
                    } else {
                      this.setState({ errorDob: null });
                      updateUser({
                        dob: moment(date).format("YYYYMMDD")
                      });
                    }
                  }}
                  selectBoxClassName={`inputField bg-white font-open-sans relative date-box ${errorDob &&
                    "redBorder"}`}
                  disabled={pageComplete}
                />
              </div>

              {errorSSN ? (
                <div className="errorText">{errorSSN}</div>
              ) : (
                <label className="inputDescriptionText mt-1 mb-1">
                  Social Security Number
                </label>
              )}

              <SSNInput
                onChange={ssn => {
                  updateUser({
                    ssn
                  });
                }}
                placeholder="XXX-XX-XXXX"
                className={`inputField inputFieldText mb-0 ${errorSSN &&
                  "redBorder"}`}
                style={{ letterSpacing: "0.5ch" }}
                disabled={pageComplete}
              />
              {errorSSN ? (
                <span className="ml-2 text-gray-500 text-sm">
                  <i className="far fa-question-circle" />
                  <span className="text-sm ml-1">
                    Trouble with SSN? Please <a href={`${process.env.REACT_APP_DOMAIN}/support`} target="_blank" className="text-green-primary">contact us.</a>
                  </span>
                </span>
              ) : (
                <></>
              )}
              {/*
                  <div>
                  <input
                    type="checkbox"
                    checked={w9Accepted}
                    name="w9"
                    onClick={e => {
                      this.setState({ errorW9: null });
                      updateUser({
                        w9Accepted: !w9Accepted
                      });
                    }}
                    disabled={pageComplete}
                  ></input>
                  {renderW9()}
                  {errorW9 && <div className="errorText mt-4">{errorW9}</div>}
                </div>
                */}
              <div>
                {error && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    {error}
                  </div>
                )}
                {networkingError && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    Error saving your data
                  </div>
                )}
                {stepError && (
                  <div
                    className="errorText"
                    style={{ position: "relative", top: 10 }}
                  >
                    {stepError}
                  </div>
                )}
              </div>
            </ReadOnly>
            <button className="continueButton cursor-pointer"
              style={{ backgroundColor: this.state.transitioning ? "gray" : "#26E3BA" }}
              disabled={this.state.transitioning}
              onClick={handleNext}
            >
              {' '}
              {this.state.showSpinner ? (
                <i className='fas fa-solid fa-circle-notch fa-spin text-2xl' />
              ) : (
                'Continue'
              )}{' '}
            </button>
           
            <div className='textContainer w-10/12 md:w-10/12'>
              <span className='text-xs'>
                This does not affect your credit score.
              </span>
            </div>
            <div style={{
                  margin: 'auto',
                  lineHeight: '1rem',
                }} className='w-10/12 md:w-8/12 leading-1 pt-1'>
              <span
                
                className='text-xs'
              >
                We ask for this information to comply with financial regulations
                and confirm your identity. Your information is encrypted with
                bank-level security and is never stored by us.
              </span>
            </div>
          </div>
        </div>
        <div className="bottomBar md:absolute inset-x-0 bottom-0">
          <div className="bottomBarText-mobile sm:bottomBarText hidden">
            <div
              onClick={() => {
                this.props.previousStep();
              }}
            >
              <Back className="backButtonIcon" />
              <input
                type="button"
                name="button"
                value="Back"
                className="backButton"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      user: state.register.user,
      applicationProgress: state.register.applicationProgress,
      step: state.register.personalInformation,
      networkingError: state.register.networkingError,
      complete: state.register.applicationProgress.personalInformation
    }),
    actions
  ),
  withModal,
  withPageStatus("personalInformation")
)(PersonalInformation);
